import React from 'react';
import styled from '@emotion/styled';

export const HeaderDesign = styled.div`
  background-image: linear-gradient(90deg, #F2F2F2 0%, #EFEFF2 51%, #E6E6F2 86%, #E0E0F3 100%);
  height: 128px;
  overflow: hidden;
  position: absolute;
  top: 0;
  width: 100%;
  left: 0;
  svg {
    position: relative;
    left: 22px;
    top: 0px;
    width: 235px;
    height: auto;
  }
  @media (min-width: 1024px) {
    height: 180px;
    svg {
      position: relative;
      left: 172px;
      top: 0px;
      width: 406px;
      height: auto;
    }
  }
  @media (min-width: 1440px) {
    height: 240px;
    svg {
      left: 172px;
      top: -120px;
      width: auto;
    } 
  }
`;

export const Root = styled.div`
  max-width: 1340px;
  margin: 0px auto -24px;
  position: relative;
  padding: 46px 22px 80px;
  @media (min-width: 1024px) {
    padding: 150px 96px 50px;
    margin-bottom: 0;
  }
  @media (min-width: 1440px) {
    padding: 183px 0px 320px;
  }
`;

export const HeaderWrap = styled.div`
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  align-items: center;
  position: relative;
  width: 100%;
  .gloassry-main-img {
    position: relative;
    width: 100%;
    max-width: 370px;
    align-self: flex-end;
    right: -26px;
    margin-top: 40px;
    height: auto;
  }
  h1 {
    color: #0318C6;
    font-family: 'syne';
    font-size: 44px;
    line-height: 48px;
    width: 338px;
  }
  .sub_header {
    color: #000;
    font-size: 20px;
    font-weight: 300;
    line-height: 27px;
    max-width: 344px;
    margin-top: 36px;
  }
  .scrollText {
    font-size: 20px;
    line-height: 30px;
    margin-top: 16px;
    font-weight: 600;
    max-width: 250px;
  }
  @media (min-width: 768px) {
    align-items: flex-start;
    padding-left: 40px;
    h1 {
      width: 520px;
    }
    .sub_header {
      max-width: 400px;
    }
    .gloassry-main-img {
      margin-top: 0px;
      top: -40px;
    }
  }
  @media (min-width: 1024px) {
    align-items: flex-start;
    padding-left: 0;
    flex-direction: row;
    .gloassry-main-img {
      position: relative;
      width: 400px;
      max-width: 400px;
      display: block;
      flex: 0 0 400px;
      align-self: flex-end;
      right: 0px;
      top: -0px;
    }
    h1 {
      color: #0318C6;
      font-family: 'syne';
      font-size: 60px;
      line-height: 56px;
      width: 530px;
    }
    .sub_header {
      color: #000;
      font-size: 25px;
      font-weight: 300;
      line-height: 38px;
      max-width: 535px;
      margin-top: 36px;
    }
    .scrollText {
      font-size: 25px;
      line-height: 34px;
      margin-top: 16px;
      font-weight: 600;
      max-width: 320px;
    }
  }
  @media (min-width: 1100px) {
    margin-bottom: 0px;
    display: flex;
    flex-direction: row;
    h1 {
      line-height: 64px;
      max-width: 700px;
      width: 100%;
    }
    .sub_header {
      max-width: 450px;      
      line-height: 1.4;
    }
    .gloassry-main-img {
      width: 600px;
      max-width: 600px;
      flex: 0 0 600px;
      top: 0px;
      right: 0;
    }
  }
  @media (min-width: 1440px) {
    margin-bottom: 0px;
    flex-direction: row;
    align-items: flex-start;
    .gloassry-main-img {
      top: -50px;
      right: 0px;
      position: relative;
      width: 650px;
      max-width: 650px;
      flex: 0 0 650px;
      height: auto;
    }
    h1 {
      font-size: 84px;
      line-height: 84px;
      margin-top: 0px;
      max-width: 680px;
    }
    .sub_header {
      font-size: 30px;
      line-height: 43px;
      max-width: 535px;
      margin-top: 36px;
    }
    .scrollText {
      font-size: 30px;
      line-height: 40px;
      margin-top: 16px;
      font-weight: 600;
      max-width: 350px;
    }
  }
`;

export const DownDiscWrap = styled.div`
  display: inline-flex;
  justify-content: center;
  align-items: center;
  width: auto;
  svg {
    width: 100px;
    height: auto;
  }
  @media (min-width: 1024px) {
    margin-top: 16px;
    margin-bottom: 100px;
    svg {
      width: 180px;
    }
  }
    @media (min-width: 1100px) {
      margin-top: 0;
      margin-bottom: 80px;
    }
    @media (min-width: 1440px) {
      margin-bottom: 100px;
    }
`;

export function DownDisc({ ...props }) {
  return (
    <svg
      width='181'
      height='181'
      viewBox='0 0 181 181'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <g clip-path='url(#clip0_1283_8439)'>
        <g filter='url(#filter0_d_1283_8439)'>
          <path
            d='M156.318 90.5C156.318 92.6391 156.195 94.8193 155.989 96.9584C155.783 99.0975 155.454 101.237 155.043 103.335C154.632 105.433 154.097 107.53 153.48 109.587C152.863 111.644 152.122 113.66 151.299 115.675C150.477 117.65 149.572 119.625 148.543 121.517C147.515 123.409 146.404 125.26 145.211 127.07C144.018 128.88 142.743 130.608 141.344 132.253C139.987 133.899 138.547 135.503 137.025 137.025C135.503 138.547 133.899 139.987 132.253 141.345C130.567 142.702 128.839 143.977 127.07 145.211C125.301 146.445 123.45 147.515 121.517 148.543C119.624 149.572 117.65 150.477 115.675 151.3C113.701 152.122 111.644 152.863 109.587 153.48C107.53 154.097 105.432 154.632 103.334 155.043C101.237 155.454 99.0974 155.783 96.9583 155.989C94.8193 156.195 92.6802 156.318 90.4999 156.318C88.3197 156.318 86.1806 156.195 84.0415 155.989C81.9024 155.783 79.7633 155.454 77.6654 155.043C75.5674 154.632 73.4695 154.097 71.4127 153.48C69.3559 152.863 67.3402 152.122 65.3245 151.3C63.3499 150.477 61.3754 149.572 59.4831 148.543C57.5909 147.515 55.7397 146.404 53.9297 145.211C52.1197 144.018 50.392 142.743 48.7465 141.345C47.0599 139.987 45.4968 138.547 43.9747 137.025C42.4527 135.503 41.0129 133.899 39.6554 132.253C38.2979 130.567 37.0227 128.839 35.7886 127.07C34.5956 125.26 33.4849 123.45 32.4565 121.517C31.4281 119.583 30.5231 117.65 29.7004 115.675C28.8777 113.701 28.1372 111.644 27.5202 109.587C26.9031 107.53 26.3684 105.433 25.957 103.335C25.5456 101.237 25.2165 99.0975 25.0109 96.9584C24.8052 94.8193 24.6818 92.6802 24.6818 90.5C24.6818 88.3198 24.8052 86.1807 25.0109 84.0416C25.2165 81.9025 25.5456 79.7634 25.957 77.6655C26.3684 75.5675 26.9031 73.4696 27.5202 71.4127C28.1372 69.3559 28.8777 67.3402 29.7004 65.3245C30.5231 63.35 31.4281 61.3755 32.4565 59.4832C33.4849 57.5909 34.5956 55.7398 35.7886 53.9298C36.9815 52.1198 38.2568 50.392 39.6554 48.7466C41.0129 47.06 42.4527 45.4968 43.9747 43.9748C45.4968 42.4527 47.1011 41.013 48.7465 39.6555C50.4331 38.298 52.1609 37.0227 53.9297 35.7886C55.7397 34.5957 57.5497 33.485 59.4831 32.4566C61.3754 31.4282 63.3499 30.5232 65.3245 29.7005C67.299 28.8777 69.3559 28.1373 71.4127 27.5202C73.4695 26.9032 75.5674 26.3684 77.6654 25.9571C79.7633 25.5457 81.9024 25.2166 84.0415 25.0109C86.1806 24.8052 88.3197 24.6818 90.4999 24.6818C92.6802 24.6818 94.8193 24.8052 96.9583 25.0109C99.0974 25.2166 101.237 25.5457 103.334 25.9571C105.432 26.3684 107.53 26.9032 109.587 27.5202C111.644 28.1373 113.66 28.8777 115.675 29.7005C117.65 30.5232 119.624 31.4282 121.517 32.4566C123.409 33.485 125.26 34.5957 127.07 35.7886C128.88 36.9816 130.608 38.2568 132.253 39.6555C133.94 41.013 135.503 42.4527 137.025 43.9748C138.547 45.4968 139.987 47.1011 141.344 48.7466C142.702 50.4332 143.977 52.1609 145.211 53.9298C146.404 55.7398 147.515 57.5498 148.543 59.4832C149.572 61.3755 150.477 63.35 151.299 65.3245C152.122 67.2991 152.863 69.3559 153.48 71.4127C154.097 73.4696 154.632 75.5675 155.043 77.6655C155.454 79.7634 155.783 81.9025 155.989 84.0416C156.195 86.1807 156.318 88.3198 156.318 90.5Z'
            fill='white'
          />
        </g>
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M90.5 67.875C91.5695 67.875 92.4334 68.6566 92.5568 69.685V69.9318V106.091L103.458 95.1895C104.198 94.4491 105.35 94.408 106.173 95.025L106.379 95.1895C107.119 95.93 107.16 97.0818 106.543 97.9045L106.379 98.1102L91.9809 112.508C91.9809 112.508 91.8575 112.631 91.8164 112.672L91.9809 112.508C91.9809 112.508 91.8163 112.631 91.7341 112.714C91.6929 112.714 91.6518 112.796 91.5695 112.796H91.4873C91.4873 112.796 91.405 112.878 91.3638 112.919H91.2404L91.117 113.002H91.0348L90.9114 113.084H90.7879C90.7879 113.084 90.7057 113.084 90.6645 113.084C90.6645 113.084 90.5823 113.084 90.5411 113.084H90.4589H90.3766H90.2532H90.4177C90.3354 113.084 90.212 113.084 90.1298 113.084H90.0063C90.0063 113.084 89.9241 113.084 89.8829 113.043H89.8007L89.6773 112.96H89.5539L89.4304 112.837H89.3482C89.3482 112.837 89.2659 112.714 89.1836 112.672C89.1836 112.672 89.0602 112.549 88.9779 112.467L74.5802 98.0691C73.7986 97.2875 73.7986 95.9711 74.5802 95.1484C75.3207 94.408 76.4725 94.3668 77.2952 94.9839L77.5009 95.1484L88.402 106.05V69.8907C88.402 68.7389 89.307 67.8339 90.4589 67.8339L90.5 67.875Z'
          fill='#0827C7'
        />
        <path
          d='M179.972 90.5C179.972 93.4207 179.848 96.3413 179.56 99.262C179.272 102.183 178.861 105.062 178.285 107.942C177.709 110.821 177.01 113.66 176.146 116.457C175.282 119.254 174.295 122.01 173.184 124.725C172.073 127.44 170.798 130.073 169.441 132.665C168.042 135.256 166.561 137.766 164.916 140.193C163.27 142.62 161.543 144.965 159.691 147.227C157.84 149.49 155.866 151.67 153.809 153.727C151.752 155.783 149.572 157.758 147.309 159.609C145.047 161.46 142.702 163.229 140.275 164.833C137.848 166.479 135.339 167.96 132.747 169.358C130.155 170.757 127.523 171.991 124.808 173.102C122.093 174.212 119.337 175.2 116.539 176.064C113.742 176.927 110.904 177.627 108.024 178.203C105.145 178.779 102.265 179.19 99.3444 179.478C96.4237 179.766 93.503 179.889 90.5823 179.889C87.6616 179.889 84.7409 179.766 81.8203 179.478C78.8996 179.19 76.02 178.779 73.1405 178.203C70.2609 177.627 67.4225 176.927 64.6253 176.064C61.828 175.2 59.0719 174.212 56.3569 173.102C53.6419 171.991 51.0091 170.716 48.4175 169.358C45.826 167.96 43.3166 166.479 40.8896 164.833C38.4625 163.188 36.1178 161.46 33.8553 159.609C31.5928 157.758 29.4125 155.783 27.3557 153.727C25.2989 151.67 23.3244 149.49 21.4732 147.227C19.6221 144.965 17.8532 142.62 16.2489 140.193C14.6034 137.766 13.1225 135.256 11.7239 132.665C10.3253 130.073 9.09118 127.44 7.98049 124.725C6.86981 122.01 5.88254 119.254 5.01868 116.457C4.15481 113.66 3.45549 110.821 2.87958 107.942C2.30368 105.062 1.89231 102.183 1.60436 99.262C1.3164 96.3413 1.19299 93.4207 1.19299 90.5C1.19299 87.5793 1.3164 84.6586 1.60436 81.7379C1.89231 78.8173 2.30368 75.9377 2.87958 73.0582C3.45549 70.1786 4.15481 67.3402 5.01868 64.5429C5.88254 61.7457 6.86981 58.9895 7.98049 56.2745C9.09118 53.5595 10.3664 50.9268 11.7239 48.3352C13.0814 45.7436 14.6034 43.2343 16.2489 40.8072C17.8944 38.3802 19.6221 36.0354 21.4732 33.7729C23.3244 31.5104 25.2989 29.3302 27.3557 27.2734C29.4125 25.2166 31.5928 23.242 33.8553 21.3909C36.1178 19.5397 38.4625 17.7709 40.8896 16.1666C43.3166 14.5211 45.826 13.0402 48.4175 11.6416C51.0091 10.2429 53.6419 9.00884 56.3569 7.89816C59.0719 6.78747 61.828 5.8002 64.6253 4.93634C67.4225 4.07248 70.2609 3.37316 73.1405 2.79725C76.02 2.22134 78.8996 1.80997 81.8203 1.52202C84.7409 1.23407 87.6616 1.11066 90.5823 1.11066C93.503 1.11066 96.4237 1.2752 99.3444 1.52202C102.265 1.80997 105.145 2.22134 108.024 2.79725C110.904 3.37316 113.742 4.07248 116.539 4.93634C119.337 5.8002 122.093 6.78747 124.808 7.89816C127.523 9.00884 130.155 10.2841 132.747 11.6416C135.339 13.0402 137.848 14.5211 140.275 16.1666C142.702 17.812 145.047 19.5397 147.309 21.3909C149.572 23.242 151.752 25.2166 153.809 27.2734C155.866 29.3302 157.84 31.5104 159.691 33.7729C161.543 36.0354 163.311 38.3802 164.916 40.8072C166.561 43.2343 168.042 45.7436 169.441 48.3352C170.839 50.9268 172.073 53.5595 173.184 56.2745C174.295 58.9895 175.282 61.7457 176.146 64.5429C177.01 67.3402 177.709 70.1786 178.285 73.0582C178.861 75.9377 179.272 78.8173 179.56 81.7379C179.848 84.6586 179.972 87.5793 179.972 90.5Z'
          stroke='white'
          strokeWidth='0.5'
        />
      </g>
      <defs>
        <filter
          id='filter0_d_1283_8439'
          x='0.681763'
          y='0.681824'
          width='179.636'
          height='179.636'
          filterUnits='userSpaceOnUse'
          color-interpolation-filters='sRGB'
        >
          <feFlood flood-opacity='0' result='BackgroundImageFix' />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset />
          <feGaussianBlur stdDeviation='12' />
          <feComposite in2='hardAlpha' operator='out' />
          <feColorMatrix type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0' />
          <feBlend mode='normal' in2='BackgroundImageFix' result='effect1_dropShadow_1283_8439' />
          <feBlend
            mode='normal'
            in='SourceGraphic'
            in2='effect1_dropShadow_1283_8439'
            result='shape'
          />
        </filter>
        <clipPath id='clip0_1283_8439'>
          <rect width='181' height='181' fill='white' />
        </clipPath>
      </defs>
    </svg>
  );
}
